import { render } from "./EditActivityModal.vue?vue&type=template&id=c52af938"
import script from "./EditActivityModal.vue?vue&type=script&lang=js"
export * from "./EditActivityModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__